import Layout from '@components/layout/Main'
import DisplaySection from '@components/display/DisplaySection'
import FlexRow from '@components/display/FlexRow'
import FlexItem from '@components/display/FlexItem'

import LinkTileGrid from '@components/add/FormLinksTileGrid'
import TruckForm from '@components/add/forms/SellTruckForm'

import useT from '@hooks/useTranslation'
import withOfferPostRequirementsFulfilled from '@hoc/withOfferPostRequirementsFulfilled'
import withOfferPostSubmitHandler from '@hoc/withOfferPostSubmitHandler'
import withOfferHighlight from '@hoc/withOfferHighlight'

import FormLinksRadio from '@components/add/FormLinksRadio'
import FormLinksTiles from '@components/add/FormLinksTiles'

import { mainLinks, sellLinks } from '@constants/addFormLinks'

import Seo from 'src/seo/components/Seo'
import useUrlSeo from 'src/seo/server/useUrlSeo'
import dbConnect from 'db/dbConnect'

const AddTruck = (props) => {
    return (
        <Layout>
            <Seo seo={props.seo} />
            <DisplaySection gray>
                <br />
                <h1 style={{ margin: 0, padding: '20px 0' }}>{useT(props.seo.h1 || 'Dodaj ogłoszenie: samochód dostawczy')}</h1>
            </DisplaySection>

            <DisplaySection white borders>
                <br />
                <FlexRow>
                    <FlexItem shrink>
                        <FormLinksRadio links={mainLinks} active={0} />
                    </FlexItem>

                    <FlexItem nopadding>
                        <LinkTileGrid>
                            <FormLinksTiles links={sellLinks} active={0} />
                        </LinkTileGrid>
                    </FlexItem>
                </FlexRow>

                <TruckForm {...props} />

                <br />
            </DisplaySection>
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()
    return {
        props: {
            seo: await useUrlSeo({
                defaultSeo: {
                    title: 'Dodaj ogłoszenie - samochód dostawczy - Dostawczaki.pl',
                    description: 'Chcesz sprzedać samochód dostawczy? Dodaj darmowe ogłoszenie. Sprzedawaj bez opłat! Sprawdź jakie to proste',
                },
                resolvedUrl: context.resolvedUrl,
            })
        }
    }
}

export default
    withOfferPostRequirementsFulfilled(
        withOfferPostSubmitHandler({ type: 'truck_ad', isSell: true, highlight: true })(
            withOfferHighlight(
                AddTruck)))